$(document).ready(function () {

    // custom select

    (function () {

        let customSelect = $('.js-custom-select'),
            selectItem = customSelect.find('select');

        function generateCustomSelect() {

            if (selectItem.length) {

                customSelect.each(function (index) {

                    let list = customSelect.eq(index).find('option');

                    customSelect.eq(index).prepend('<input type="text" readonly>');
                    customSelect.eq(index).append('<input type="hidden">');
                    customSelect.eq(index).append('<div class="dropdown-list"></div>');
                    customSelect.eq(index).find('.dropdown-list').append('<ul></ul>');

                    list.each(function (i) {
                        if (list.eq(i).attr('selected') !== undefined) {
                            list.eq(i).closest(customSelect).children('[type="text"]').val(list.eq(i).text());
                            customSelect.eq(index).find('ul').append('<li class="active" data-value="' + list.eq(i).attr('value') + '">' + list.eq(i).text() + '</li>');
                        } else {
                            customSelect.eq(index).find('ul').append('<li data-value="' + list.eq(i).attr('value') + '">' + list.eq(i).text() + '</li>');
                        }
                    })
                });
            }
        }

        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

            generateCustomSelect();
            selectItem.remove();

            function closeAll() {
                customSelect.each(function (index) {
                    if (customSelect.eq(index).hasClass('active')) {
                        customSelect.eq(index).removeClass('active');
                    }
                })
            }

            function clearActive(arr) {
                arr.each(function (index) {
                    arr.eq(index).removeClass('active');
                });
            }

            //click on select

            customSelect.click(function () {

                let index = customSelect.index(this);

                if (customSelect.eq(index).hasClass('active')) {

                    closeAll();

                } else {

                    closeAll();
                    customSelect.eq(index).addClass('active');

                }

            });

            $(document).on('click touchstart', function (e) {
                if (!$(e.target).closest(customSelect).length) {
                    closeAll();
                }
            });


            // click on select item

            customSelect.on('click', 'li', function () {

                if ($(this).closest(customSelect).hasClass('active')) {

                    clearActive($(this).parent().children('li'));
                    $(this).addClass('active');
                    $(this).closest(customSelect).children('[type="text"]').val($(this).text());
                    $(this).closest(customSelect).children('[type="hidden"]').val($(this).attr('data-value'));
                }
            });
        }

    })();

});


// WEBPACK FOOTER //
// ./scripts/custom-select.js